import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useLang } from "../contexts/LanguageContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) { toast.success("Welcome back!"); nav("/"); }
    else toast.error(res.error);
  };

  return (
    <div className="container-deg py-20 md:py-28 max-w-md" data-testid="login-page">
      <div className="overline">{t("nav.login")}</div>
      <h1 className="font-serif text-4xl mt-3">{t("auth.login_title")}</h1>
      <p className="text-ink-soft mt-3">{t("auth.login_sub")}</p>
      <form onSubmit={submit} className="mt-10 space-y-6">
        <div>
          <label className="overline">{t("auth.email")}</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-deg mt-2" data-testid="login-email" />
        </div>
        <div>
          <label className="overline">{t("auth.password")}</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-deg mt-2" data-testid="login-password" />
        </div>
        <button type="submit" disabled={loading} className="btn-primary w-full disabled:opacity-60" data-testid="login-submit">
          {loading ? t("common.loading") : t("auth.sign_in")}
        </button>
      </form>
      <p className="mt-8 text-sm text-ink-soft">
        {t("auth.no_account")} <Link to="/register" className="text-accent hover:underline" data-testid="login-register-link">{t("auth.sign_up")}</Link>
      </p>
    </div>
  );
}
